module.exports = __webpack_public_path__ + "img/01.e0c3d775.jpg";